exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.glued-left-min-width[data-v-7a67c4f6] {\n  min-width: 2.25rem;\n}\n.custom-fields[data-v-7a67c4f6] {\n  overflow: auto;\n  max-height: 24.5rem;\n}\n.initial-height[data-v-7a67c4f6] {\n  min-height: 2.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7a67c4f6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/TabPresets.vue
// module id = 2482
// module chunks = 0